// extracted by mini-css-extract-plugin
export default {"container":"breadcrumbs_container__atoDZ","crumb":"breadcrumbs_crumb__+8eQd","link":"breadcrumbs_link__ULnLE"};